<template>
  <ItemPage
    title="Avaliação Nacional"
    size="lg"
    :actions="actions"
  >
    <template v-if="questionsView">
      <v-simple-table fixed-header>
        <Load v-if="loading" />
        <div
          v-else
        >
          <v-data-table
            :headers="headers"
            :items="exams"
            :items-per-page="15"
            hide-default-footer
            item-key="id"
          >
            <template #item.title="{ item }">
              <router-link :to="{ name: 'exams.examId', params: { examId: item.id } }">
                {{ item.title }}
              </router-link>
            </template>
            <template #item.is_published="{ item }">
              {{ item.is_published? 'Publicada' : 'Despublicada' }}
            </template>

            <template #item.created_at="{ item }">
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="openEditExamDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="deleteExam(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-simple-table>

      <v-pagination
        v-model="page"
        :length="totalPages"
        :total-visible="5"
        class="mt-4"
      />
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import NewExamDialog from './components/NewExamDialog.vue'
import EditExamDialog from './components/EditExamDialog.vue'
import Load from '@/components/Loading.vue'
import { getTextForDisplay as volumeName } from '@/enums/volumeAudeExam'
import { getTextForDisplay as gradeLevelName } from '@/enums/gradeLevelAudeExam'
import utils from '@/api/utils.js'

export default {
  components: {
    ItemPage,
    Load
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      questionsView: true,
      questionsCreate: true,
      loading: false,
      exams: [],
      search: '',
      headers: [
        {
          text: 'Id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Titulo',
          align: 'start',
          value: 'title'
        },
        {
          text: 'Sub titulo',
          align: 'start',
          value: 'subtitle'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'is_published'
        },
        {
          text: 'Ações',
          align: 'start',
          value: 'created_at'
        }
      ],

      // Pagination
      page: 1,
      totalPages: 1
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Nova avaliação',
          action: this.openNewExamDialog,
          icon: 'mdi-plus',
          disabled: !this.questionsCreate
        }
      ]
    }
  },
  watch: {
    page (newValue) {
      if (newValue) {
        this.listExams()
      }
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    volumeName,
    gradeLevelName,
    fetchAll () {
      this.listExams()
      this.questionsView = utils.checkPermissions('questions.view-any')
      this.questionsCreate = utils.checkPermissions('questions.create')
    },

    async listExams (page) {
      this.loading = true
      try {
        const response = await this.$api.listExams(this.page)
        this.exams = response.data
        this.totalPages = response.meta.last_page
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar listar avaliações.', color: 'red' })
        this.getErrors(e)
        this.loading = false
      }
      this.loading = false
    },

    goToExam (event) {
      this.$router.push({ name: 'exams.id', params: { id: event.id } })
    },

    openNewExamDialog () {
      this.$dialog.custom(NewExamDialog).show()
        .then(() => {
          this.listExams()
        })
    },
    openEditExamDialog (item) {
      this.$dialog.custom(EditExamDialog).with({ exam: item }).show()
        .then(async () => {
          await this.listExams()
        })
    },

    async deleteExam (exam) {
      this.$dialog.confirm('Apagar Avaliação?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          this.loading = true
          try {
            await this.$api.deleteExam(exam.id)
            this.$store.dispatch('setSnackBar', { text: 'Avaliação excluída com sucesso.' })
            await this.listExams()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar excluir avaliação.', color: 'red' })
          } finally {
            this.loading = false
          }
        })
        .show()
    }
  }
}
</script>
